export default __webpack_public_path__ + "media/images/banner/banner-6-e4a9529654049582e9fdf3b7560d1162.jpg";